/**
 * Represents a parsed online help document ready for display.
 * Contains the extracted title (from the first H1 heading) and
 * the full markdown content rendered as HTML.
 */
export class OnlineHelpDocument {
  /** The document title extracted from the first H1 heading in the markdown source */
  title: string;

  /** The fully rendered HTML content of the markdown document */
  htmlContent: string;

  constructor(title: string, htmlContent: string) {
    this.title = title;
    this.htmlContent = htmlContent;
  }
}
